import { Product, ProductActions, ProductEvents } from './types';

export interface ProductState {
    // Store products by their IDs
    byIds: Record<string, Product>;

    // Track the most recently viewed product's ID
    recentlyViewedProductId: string | null;
}

export const initialState: ProductState = {
    byIds: {},
    recentlyViewedProductId: null,
};

export function productReducer(state = initialState, action: ProductActions): ProductState {
    switch (action.type) {
        case ProductEvents.VIEW_PRODUCT: {
            const product = action.payload;

            if (!product?.id) {
                return state;
            }

            return {
                ...state,
                byIds: {
                    ...state.byIds,
                    [product.id]: product,
                },
                recentlyViewedProductId: product.id,
            };
        }

        default:
            return state;
    }
}
